<template>
  <el-row v-if="isGuidanceTipShow" class="tooltip-line-content-wrapper">
    <el-col :span="24">
      <div class="guidance-tip">
        {{ content }}
        <slot name="btn">
          <span class="bind-btn" @click="() => $store.commit('setShopVisiable', { visiable: true })">
            <!-- {{ $t('system::common::btn::auth_shop') }} -->
            {{ $t('stores::store::bind_shop') }}
          </span>
        </slot>
        <span class="bind-btn" v-if="tip" @click="onClick">{{ $t('system::common::btn::example') }}</span>
        <img
          v-show="showClose"
          class="close-img"
          src="../../assets/images/userGuidance/close.png"
          alt=""
          @click="
            () => {
              isGuidanceTipShow = false
              $emit('close')
            }
          "
        />
      </div>
    </el-col>
    <div style="overflow: hidden; height: 0; width: 0">
      <el-image v-if="tip" ref="imgShow" :preview-src-list="[tip]" :src="tip"></el-image>
    </div>
  </el-row>
</template>
<script>
export default {
  name: 'tooltipLine',
  props: {
    tip: {
      default: '', //图片
    },
    content: {
      default: '您暂未授权任何店铺',
    },
    visible: {
      default: false,
    },
    showClose: {
      default: true,
    },
  },
  watch: {
    visible: {
      handler: function (bool) {
        this.isGuidanceTipShow = bool
      },
      immediate: true,
    },
  },
  data() {
    return {
      isGuidanceTipShow: true,
    }
  },
  methods: {
    onClick() {
      this.$refs.imgShow.clickHandler()
    },
  },
}
</script>
<style lang="scss">
.tooltip-line-content-wrapper {
  .guidance-tip {
    display: flex;
    align-items: center;
    // width: 453px;
    height: 40px;
    background: #fbf5db;
    border-radius: 5px;
    margin-bottom: 14px;
    line-height: 40px;
    padding-left: 30px;
    font-size: 14px;
    font-weight: 400;
    color: #323232;
    position: relative;
    .bind-btn {
      font-size: 14px;
      font-weight: 400;
      color: #ff4c00;
      margin-left: 12px;
      cursor: pointer;
    }
    .close-img {
      cursor: pointer;
      width: 17px;
      height: 17px;
      position: absolute;
      right: 14px;
    }
  }
}
</style>
